import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')
const CONTACT_URL = `${API_URL}api/v1/contact/`

export const HR_CONTACT_PATH = '/hr/contact'

/** ContactDto */
export interface IContactModel {
  id: string
  name: string
  email: string
  phone?: string | null
  title?: string | null
  note?: string | null
  createdDate?: string
}

export interface IContactRequest {
  name: string
  email: string
  phone: string
  title: string
  note: string
}

export function searchContacts(
  q: string,
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IContactModel>>>> {
  return corporateApi.get(`${CONTACT_URL}search`, {params: {...(q ? {q} : {}), page, size, sort: 'name'}})
}

export function createContact(request: IContactRequest) {
  return corporateApi.post(`${CONTACT_URL}create`, request)
}

export function updateContact(id: string, request: IContactRequest) {
  return corporateApi.patch(`${CONTACT_URL}update/${id}`, request)
}

export function deleteContact(id: string) {
  return corporateApi.delete(`${CONTACT_URL}delete/${id}`)
}
